import { render } from "./404Page.vue?vue&type=template&id=2280bc65&scoped=true"
import script from "./404Page.vue?vue&type=script&lang=js"
export * from "./404Page.vue?vue&type=script&lang=js"

import "./404Page.vue?vue&type=style&index=0&id=2280bc65&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2280bc65"]])

export default __exports__